import {applyEventsToBtn} from "../../common/dom";
import {updateParentChildSize} from "../../common/window";
import {isMobileOrTablet} from "../../common/misc";

export function loadHeader() {
    setupCollapsibleMenu();
    setupScrollable();
    setupTabs();

    _headerOnLoad();
    document.addEventListener("load", _headerOnLoad, false);
    document.addEventListener("resize", _headerOnResize, false);
}

function setupCollapsibleMenu() {
    const navbar = document.querySelector('.navbar');
    if (navbar) {
        const navContainer = navbar.querySelector('.nav-container');
        const container = navbar.querySelector('.container-fluid');
        const brandContainer = navbar.querySelector('.brand-container');
        const tabsLists = navbar.querySelectorAll('ul.tabs-list');
        const navIcon = navbar.querySelector('#nav-icon');
        if (!navContainer || !container || !brandContainer || !tabsLists || !navIcon) {
            return;
        }

        navIcon.addEventListener("click", function (evt) {
            navIcon.classList.toggle('open');
            navContainer.classList.toggle('open');
            toggleTreeElements();
        });

        let usedWidth = brandContainer.clientWidth + 18;
        for (let i = 0; i < tabsLists.length; i++) {
            const style = getComputedStyle(tabsLists[i]);
            usedWidth += parseFloat(style.marginLeft) + parseFloat(style.marginRight);
            for (let j = 0; j < tabsLists[i].children.length; j++)
                usedWidth += tabsLists[i].children[j].clientWidth;
        }

        const doResize = function () {
            const availWidth = container.clientWidth;
            if (usedWidth > availWidth) {
                navContainer.classList.add('collapsed');
            } else {
                navContainer.classList.remove('collapsed');
                navIcon.classList.remove('open');
            }
        };

        doResize();

        window.addEventListener('resize', function() {
            if (!GlobalEnt.resizeTimeout) {
                GlobalEnt.resizeTimeout = setTimeout(function () {
                    GlobalEnt.resizeTimeout = null;
                    doResize();
                }, 10);
            }
        });
    }

    const tabOptLinks = document.querySelectorAll('.tab-opt-link');
    if (tabOptLinks && !window.matchMedia("(max-width: 480px)").matches) {
        tabOptLinks.forEach((tabOptLink) => {
            const { action } = tabOptLink.dataset;
            if (action) {
                applyEventsToBtn(tabOptLink, (e) => {
                    e.stopPropagation();
                    document.location = action;
                });
            }
        });
    }
}

function toggleTreeElements() {
    const treeLink = document.querySelector('.vertical-tree-link');
    if (treeLink) {
        treeLink.classList.toggle('hidden');
    }
    const treeCollapse = document.querySelector('.tree-collapse');
    if (treeCollapse) {
        treeCollapse.classList.toggle('hidden');
    }
    const treeExpand = document.querySelector('.tree-expand');
    if (treeExpand) {
        treeExpand.classList.toggle('hidden');
    }
}


function setupScrollable() {
    const bodyHeader = document.querySelector('.body-header');
    const listingHeader = document.querySelector('.listing-header');
    const tableListingActions = document.querySelector('.listing-header-table-listing-actions');
    if (!bodyHeader || !listingHeader) {
        return;
    }

    document.addEventListener("scroll", function (e) {
        if (!GlobalEnt.isScrolling) {
            window.requestAnimationFrame(function () {
                const spaceAbove = getOffsetTop(bodyHeader);
                const scrolledDistance = document.documentElement.scrollTop;
                const height = listingHeader.clientHeight;

                if (scrolledDistance >= spaceAbove) {
                    if (tableListingActions && isMobileOrTablet()) {
                        tableListingActions.classList.add('hidden');
                    }

                    listingHeader.classList.add('fixed-scroll');
                    listingHeader.style.top = height + "px";
                    bodyHeader.style.paddingBottom = height + "px";
                } else {
                    if (tableListingActions && isMobileOrTablet()) {
                        tableListingActions.classList.remove('hidden');
                    }

                    listingHeader.classList.remove('fixed-scroll');
                    bodyHeader.style.paddingBottom = "0px";
                }

                GlobalEnt.isScrolling = false;
            });

            GlobalEnt.isScrolling = true;
        }
    });

    const getOffsetTop = function(element) {
        let offsetTop = 0;
        if (element.offsetParent) {
            do {
                offsetTop += element.offsetTop;
            } while ((element = element.offsetParent));
        }
        return offsetTop;
    };
}


function setupTabs() {
    const tabItems = document.querySelectorAll('.tab');
    for (let i = 0; i < tabItems.length; i++) {
        const tabItem = tabItems[i];
        if (isMobileOrTablet() && tabItem.children.length > 0) {
            const aEls = tabItem.querySelectorAll('a');

            for (let a = 0; a < aEls.length; a++) {
                const aEl = aEls[a];
                aEl.addEventListener("click", function (evt) {
                    evt.preventDefault();
                    evt.stopPropagation();

                    // Clear Active Tabs.
                    clearActiveTabs(tabItem, tabItems);

                    if (tabItem.classList.contains('hovered')) {
                        tabItem.classList.remove('hovered');
                    } else {
                        tabItem.classList.add('hovered');
                    }
                });
            }
        }

        tabItem.addEventListener("mouseover", function (evt) {
            evt.stopPropagation();
            tabItem.classList.add('hovered');
        });

        tabItem.addEventListener("mouseout", function (evt) {
            evt.stopPropagation();
            tabItem.classList.remove('hovered');
        });

        if (!isMobileOrTablet()) {
            const tabLinks = tabItem.querySelectorAll('.tab-link');
            if (tabLinks) {
                for (let l = 0; l < tabLinks.length; l++) {
                    const tabLink = tabLinks[l];
                    const { action } = tabLink.dataset;
                    if (action) {
                        tabLink.addEventListener('click', function() {
                            window.location = action;
                        });
                    }
                }
            }
        }

        const subTabs = tabItem.querySelectorAll('.tab-opt');
        for (let j = 0; j < subTabs.length; j++) {
            const subTab = subTabs[j];
            if (isMobileOrTablet() && subTab.children.length > 0) {
                const aEls = subTab.querySelectorAll('a');
                for (let a = 0; a < aEls.length; a++) {
                    const aEl = aEls[a];
                    aEl.addEventListener("click", function (evt) {
                        window.location = aEl.href;
                    });
                }
            }

            if (!isMobileOrTablet()) {
                subTab.addEventListener("mouseover", function (evt) {
                    subTab.classList.add('hovered');
                });

                subTab.addEventListener("mouseout", function (evt) {
                    subTab.classList.remove('hovered');
                });
            }
        }
    }
}

function clearActiveTabs(tabItem, tabItems) {
    for (let i = 0; i < tabItems.length; i++) {
        const currentTab = tabItems[i];
        if (currentTab !== tabItem) {
            currentTab.classList.remove('active', 'hovered');
        }
    }
}

function _headerOnLoad() {
    _headerOnResize();
}

function _headerOnResize() {
    updateParentChildSize("PARENT");
}